// removed by extract-text-webpack-plugin
module.exports = {"sidebar-padding":"_2-ZZC","sidebar-margin":"L8K64","sidebar":"_1-jio _1s_jv","breadcrumbs":"_2YdM- _2-ZZC","item":"_1qQzv _38618 _3Dqep _1s_jv _2-ZZC _2rmlO _18Xrq","sectionTitle":"_143k8 _38618 _3Dqep _1s_jv _2-ZZC _2FnGH _3TD8R","icon":"saWAj _9DUFn","selected":"_1CO2D","divider":"_2A40N _1ocN4 GjCgU L8K64","name":"_1IN-G _1Wqf2 _3TD8R","noLabelsMessage":"_2zt9Q _18-EI rTQr- _2z9kb _14leg Pvqsl L8K64"};


//////////////////
// WEBPACK FOOTER
// ./components/Sidebar.css
// module id = 273
// module chunks = 3